<script>
    import {showLightBox} from "../stores/misc";
    import {fileExtensionFromFilename, inArray} from "../../../../../lib/utils";

    export let files = [];
    const image_extensions = [
        '.png',
        '.jpg',
        '.jpeg',
        '.webp',
        '.webm', // ?
        '.tif',
    ];

    const stripDateFromFilename = filename => {
        return `${filename.split('__')[0]}${fileExtensionFromFilename(filename)}`;
    }

</script>


<ul role="list" class="divide-y divide-gray-200 rounded-md border border-gray-200">
    {#each files as filename}
        {#if inArray(image_extensions, fileExtensionFromFilename(filename).toLowerCase()) }
        <li>
            <a on:click|preventDefault={() => showLightBox(`/api/file/${filename}`)} href="/" class="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                <div class="flex w-0 flex-1 items-center">
                    <svg class="h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd"></path>
                    </svg>
                    <span class="ml-2 w-0 flex-1 truncate">{stripDateFromFilename(filename)}</span>
                </div>
                <div class="ml-4 flex-shrink-0">
                        <span class="font-medium text-blue-600 hover:text-blue-500">Show</span>
                </div>
            </a>
        </li>
        {:else}
        <li>
            <a href="/api/file/{filename}" class="flex items-center justify-between py-3 pl-3 pr-4 text-sm" target="_blank">
                <div class="flex w-0 flex-1 items-center">
                    <svg class="h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd"></path>
                    </svg>
                    <span class="ml-2 w-0 flex-1 truncate">{stripDateFromFilename(filename)}</span>
                </div>
                <div class="ml-4 flex-shrink-0">
                    <span class="font-medium text-blue-600 hover:text-blue-500" >Download</span>
                </div>
            </a>
        </li>
        {/if}
    {/each}
</ul>


<style></style>